document.addEventListener('DOMContentLoaded', function () {

    // Run immediately if DOM is ready, or wait

    if (document.readyState === 'loading') {

        document.addEventListener('DOMContentLoaded', initCleanGallery);

    } else {

        initCleanGallery();

    }

});



function initCleanGallery() {

    // 1. Find the original gallery component to replace

    const originalGallery = document.querySelector('media-gallery') || document.querySelector('.product__media-wrapper');

    if (!originalGallery) return;
    if (originalGallery.closest('.bee-product-page')) return;



    // 2. Extract all image data from the original gallery

    // We look for all images inside the gallery

    const originalImages = originalGallery.querySelectorAll('img');

    if (originalImages.length === 0) return;



    const imageData = Array.from(originalImages).map(img => ({

        src: img.src,

        srcset: img.srcset,

        alt: img.alt || ''

    }));



    // 3. Create the New Gallery Structure

    const galleryWrapper = document.createElement('div');

    galleryWrapper.className = 'custom-gallery-wrapper';



    // --- Main Image Area ---

    const mainImageContainer = document.createElement('div');

    mainImageContainer.className = 'custom-main-image-container';



    const mainImage = document.createElement('img');

    mainImage.className = 'custom-main-image';

    // Set initial image (first one)

    if (imageData.length > 0) {

        mainImage.src = imageData[0].src;

        mainImage.srcset = imageData[0].srcset;

        mainImage.alt = imageData[0].alt;

    }

    mainImageContainer.appendChild(mainImage);

    galleryWrapper.appendChild(mainImageContainer);



    // --- Thumbnails Area ---

    // Only create thumbnails if there is more than 1 image

    if (imageData.length > 1) {

        const thumbsTrack = document.createElement('div');

        thumbsTrack.className = 'custom-thumbnails-track';



        imageData.forEach((data, index) => {

            const thumbItem = document.createElement('div');

            thumbItem.className = 'custom-thumb-item';

            if (index === 0) thumbItem.classList.add('active-thumb');



            const thumbImg = document.createElement('img');

            thumbImg.src = data.src;

            // Use a smaller version for thumb if possible, but for now src is fine

            // thumbImg.srcset = data.srcset; 

            thumbImg.alt = data.alt;



            thumbItem.appendChild(thumbImg);



            // Click Event: Swap Main Image

            thumbItem.addEventListener('click', () => {

                // Update Active State

                document.querySelectorAll('.custom-thumb-item').forEach(el => el.classList.remove('active-thumb'));

                thumbItem.classList.add('active-thumb');



                // Swap Image with Fade Effect

                mainImage.style.opacity = '0.6';

                setTimeout(() => {

                    mainImage.src = data.src;

                    mainImage.srcset = data.srcset;

                    mainImage.alt = data.alt;

                    mainImage.style.opacity = '1';

                }, 150);

            });



            thumbsTrack.appendChild(thumbItem);

        });



        galleryWrapper.appendChild(thumbsTrack);

    }



    // 4. Hide Original Gallery and Insert New One

    originalGallery.style.display = 'none'; // Hide original

    originalGallery.parentNode.insertBefore(galleryWrapper, originalGallery);

}

